import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { InstutionFunction, InstutionFunctionInput } from './instution-function.model';

export const loadInstutionFunctions = createAction(
  '[InstutionFunction/API] Load InstutionFunctions',
  props<{ instutionFunctions: InstutionFunction[] }>()
);

export const addInstutionFunction = createAction(
  '[InstutionFunction/API] Add InstutionFunction',
  props<{ instutionFunction: InstutionFunction }>()
);

export const upsertInstutionFunction = createAction(
  '[InstutionFunction/API] Upsert InstutionFunction',
  props<{ instutionFunction: InstutionFunction }>()
);

export const addInstutionFunctions = createAction(
  '[InstutionFunction/API] Add InstutionFunctions',
  props<{ instutionFunctions: InstutionFunction[] }>()
);

export const upsertInstutionFunctions = createAction(
  '[InstutionFunction/API] Upsert InstutionFunctions',
  props<{ instutionFunctions: InstutionFunction[] }>()
);

export const updateInstutionFunction = createAction(
  '[InstutionFunction/API] Update InstutionFunction',
  props<{ instutionFunction: Update<InstutionFunction> }>()
);

export const updateInstutionFunctions = createAction(
  '[InstutionFunction/API] Update InstutionFunctions',
  props<{ instutionFunctions: Update<InstutionFunction>[] }>()
);

export const deleteInstutionFunction = createAction(
  '[InstutionFunction/API] Delete InstutionFunction',
  props<{ id: string }>()
);

export const deleteInstutionFunctions = createAction(
  '[InstutionFunction/API] Delete InstutionFunctions',
  props<{ ids: string[] }>()
);

export const clearInstutionFunctions = createAction(
  '[InstutionFunction/API] Clear InstutionFunctions'
);


//CUSTOM

export const createInstitutionFunction = createAction(
  '[InstutionFunction/API] Create Institution Function',
  props<{ input:InstutionFunctionInput }>()
);


export const updateInstitutionFunction = createAction(
  '[InstutionFunction/API] Update Institution Function',
  props<{ input:InstutionFunctionInput }>()
);

export const removeInstutionFunction = createAction(
  '[InstutionFunction/API] Remove Instution Function',
  props<{ functionUniqueId: string,id:string }>()
);


export const getAllFunctions = createAction(
  '[InstutionFunction/API] All Instution Functions',
  props<{
    instituteUniqueId: string
  }>()
);








